function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.9974 0.166016C4.3974 0.166016 0.664062 3.89935 0.664062 8.49935C0.664062 13.0993 4.3974 16.8327 8.9974 16.8327C13.5974 16.8327 17.3307 13.0993 17.3307 8.49935C17.3307 3.89935 13.5974 0.166016 8.9974 0.166016ZM8.9974 15.166C5.3224 15.166 2.33073 12.1743 2.33073 8.49935C2.33073 4.82435 5.3224 1.83268 8.9974 1.83268C12.6724 1.83268 15.6641 4.82435 15.6641 8.49935C15.6641 12.1743 12.6724 15.166 8.9974 15.166ZM7.33073 10.3077L12.8224 4.81608L13.9974 5.99941L7.33073 12.6661L3.9974 9.33275L5.1724 8.15775L7.33073 10.3077Z",
  fill: "none"
});

function SvgCircledCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheckGreen);
export default __webpack_public_path__ + "static/media/CircledCheckGreen.bc93012c.svg";
export { ForwardRef as ReactComponent };